/**
 * Help Center Categories
 * 
 * 8 categories matching Revolut's structure
 */

import {
  AlertTriangle,
  ArrowDownToLine,
  ArrowUpFromLine,
  Percent,
  Receipt,
  Rocket,
  Shield,
  User,
} from "lucide-react";
import type { HelpCategory } from "./types";

export const HELP_CATEGORIES: HelpCategory[] = [
  {
    id: "getting-started",
    title: "Getting Started",
    description: "Everything you need to start using Supabank",
    icon: Rocket,
    order: 1,
  },
  {
    id: "account",
    title: "Account & Profile",
    description: "Manage your account settings and profile",
    icon: User,
    order: 2,
  },
  {
    id: "deposits",
    title: "Deposits & Funding",
    description: "How to fund your account with crypto",
    icon: ArrowDownToLine,
    order: 3,
  },
  {
    id: "withdrawals",
    title: "Withdrawals & Payouts",
    description: "Get fiat to your bank account",
    icon: ArrowUpFromLine,
    order: 4,
  },
  {
    id: "transactions",
    title: "Transactions",
    description: "Track and understand your transactions",
    icon: Receipt,
    order: 5,
  },
  {
    id: "limits-fees",
    title: "Limits & Fees",
    description: "Understand pricing and limits",
    icon: Percent,
    order: 6,
  },
  {
    id: "security",
    title: "Security",
    description: "Keep your account safe",
    icon: Shield,
    order: 7,
  },
  {
    id: "troubleshooting",
    title: "Troubleshooting",
    description: "Solutions to common issues",
    icon: AlertTriangle,
    order: 8,
  },
];

export function getCategoryById(id: string): HelpCategory | undefined {
  return HELP_CATEGORIES.find((cat) => cat.id === id);
}
